import { Component, input } from '@angular/core';
import { BusinessHoursPipe } from '../../../../../../common/pipes/business-hours.pipe';
import type { PointOfInterest } from '../../interfaces/point-of-interest';

@Component({
  selector: 'app-points-of-interest-opening-hours-cell',
  imports: [BusinessHoursPipe],
  templateUrl: './points-of-interest-opening-hours-cell.component.html',
  styleUrl: './points-of-interest-opening-hours-cell.component.scss',
})
export class PointsOfInterestOpeningHoursCellComponent {
  public readonly businessHours = input.required<
    PointOfInterest['businessHours'] | null
  >();
}
